import { extractYouTubeVideoId } from '../misc/extractYouTubeVideoId';

export function getVideoId(pathMateri: string | undefined, metode: string | number | undefined): string | null {
  if (!pathMateri) return null;
  if (Number(metode) === 1) return pathMateri;
  return extractYouTubeVideoId(pathMateri);
}
